import { z } from 'zod';
import { DocumentType } from '../client';
import { makeEvent } from './EventBase';

export const DocumentTypesUpdated = makeEvent(
    'DocumentTypesUpdated',
    z.object({
        data: DocumentType.array(),
    }),
);

export type DocumentTypesUpdated = (typeof DocumentTypesUpdated)['schema']['_output'];
